import React, { useEffect } from "react";
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";

const style = { layout: "vertical" };

const ButtonWrapper = ({ currency, showSpinner, amount, purchaseUnits, onCreateOrder, onInit, onError, onCancel, onApprove }) => {
  // usePayPalScriptReducer can be use only inside children of PayPalScriptProviders
  // This is the main reason to wrap the PayPalButtons in a new component
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();

  useEffect(() => {
    dispatch({
      type: "resetOptions",
      value: {
        ...options,
        currency: currency,
      },
    });
  }, [currency, purchaseUnits, amount]);

  return (
    <>
      {showSpinner && isPending && <div className="spinner" />}
      <PayPalButtons
        style={style}
        disabled={false}
        forceReRender={[purchaseUnits, amount, currency]}
        fundingSource={"paypal"}
        createOrder={(data, actions) => {
          return actions.order
            .create({
              purchase_units: [...purchaseUnits],

              shipping_type: "NO_SHIPPING",
              application_context: {
                shipping_preference: "NO_SHIPPING",
              },
            })
            .then((orderId) => {
              onCreateOrder(orderId);
              return orderId;
            })
            .catch((err) => {
              console.error("Create Order Error:", err);
            });
        }}
        onApprove={function (data, actions) {
          return actions.order.capture().then((details) => {
            onApprove(data, actions, details);
          });
        }}
        onCancel={function (data, actions) {
          onCancel(data, actions);
        }}
        onError={function (data) {
          onError(data);
        }}
        onInit={function (data) {
          onInit(data);
        }}
      />
    </>
  );
};

export default ButtonWrapper;
